import React from 'react';
import PropTypes from 'prop-types';
import ListGroup from 'react-bootstrap/Listgroup';

const Category = (props) => {
    let currentId = -1;
    if (props.currentCategory) {
        currentId = props.currentCategory.id;
    }

    return (
        <ListGroup.Item action={true} onClick={() => {
            props.onClick(props.category);
        }} className={currentId === props.category.id ? 'active' : ''}>
            {props.category.name}
        </ListGroup.Item>
    );
};

Category.propTypes = {
    category: PropTypes.object,
    currentCategory: PropTypes.object,
    onClick: PropTypes.func
};

export default Category;
